class MiltonToast extends HTMLElement {
    constructor() {
        super();
        this.errorToast = null;
        this.successToast = null;
    }

    connectedCallback() {
        this.errorToast = this.querySelector("error-toast");
        this.successToast = this.querySelector("success-toast");
    }

    showToast(type, message) {
        const toastElement =
            type === "success" ? this.successToast : this.errorToast;
        const messageElement = toastElement.querySelector(
            type === "success" ? "success-message" : "error-message"
        );

        messageElement.textContent = message;
        this.classList.add("active");
        toastElement.classList.add("active");
        this.animateToast(toastElement);
    }

    animateToast(toastElement) {
        const progressBar = toastElement.querySelector("toast-progress-bar");
        progressBar.style.width = "100%";

        requestAnimationFrame(() => {
            progressBar.style.transition = "width 3s linear";
            progressBar.style.width = "0%";
        });

        setTimeout(() => {
            this.hideToast(toastElement);
        }, 3000);
    }

    hideToast(toastElement) {
        toastElement.classList.remove("active");
        this.classList.remove("active");
        const progressBar = toastElement.querySelector("toast-progress-bar");
        progressBar.style.transition = "";
        progressBar.style.width = "100%";
    }

    showSuccessToast(message) {
        this.showToast("success", message);
    }

    showErrorToast(message) {
        this.showToast("error", message);
    }
}

customElements.define("milton-toast", MiltonToast);

class ModalContainer extends HTMLElement {
    constructor() {
        super();
        this.modal = this.querySelector('modal-viewer');
        this.modalOverlay = this.querySelector('modal-overlay');
        this.modalButton = this.querySelector('modal-button');
        this.modalContent = this.querySelector('modal-content');
        this.allModalClose = this.querySelectorAll('modal-close');

        this.toggleModal = this.toggleModal.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);

        this.modalButton?.addEventListener('click', () => this.toggleModal(true));
        this.allModalClose.forEach(closeBtn => closeBtn?.addEventListener('click', () => this.toggleModal(false)));
        this.modalOverlay?.addEventListener('click', () => this.toggleModal(false));

        window.addEventListener("popstate", this.handleBackButton);
    }

    toggleModal(isOpening = null) {
        const isOpen = this.modal.classList.contains('active');
        const shouldOpen = isOpening ?? !isOpen;

        if (shouldOpen) {
            document.body.classList.add('overflow-hidden');            
            this.modal.classList.add('active');            
            history.pushState({ modalOpen: true }, "", location.href);            
        } else {
            document.body.classList.remove('overflow-hidden');
            this.modal.classList.remove('active');            
            // Only manipulate history if the modal was open
            if (history.state?.modalOpen) {
                history.replaceState(null, "", location.href);
            }
            const bulkPersonalizeElement = document.querySelector('.bulk-personalize');
            if (bulkPersonalizeElement) {
                bulkPersonalizeElement.classList.remove('bs-invisible');
            }            
        }
    }

    handleBackButton(event) {
        if (this.modal.classList.contains('active')) {
            this.toggleModal(false);
            event.preventDefault();
        }
    }
}

customElements.define('modal-container', ModalContainer);
class PersonalizeModalContainer extends HTMLElement {
    constructor() {
        super();
        this.modal = this.querySelector('modal-viewer');
        this.modalOverlay = this.querySelector('modal-overlay');
        this.modalButton = this.querySelector('modal-button');
        this.modalContent = this.querySelector('modal-content');
        this.allModalClose = this.querySelectorAll('modal-close');
        
        this.confirmationPopup = this.querySelector('.switch-confirmation-popup');
        this.confirmSwitchBtn = this.confirmationPopup?.querySelector('[data-action="confirm-switch"]');
        this.cancelSwitchBtn = this.confirmationPopup?.querySelector('[data-action="cancel-switch"]');
        this.popupCloseBtn = this.confirmationPopup?.querySelector('[data-action="close-popup"]');
        
        this.singlePersonalizationBtns = this.querySelectorAll('.single-personalization-button, .personalization-buttons button:first-child');
        this.bulkPersonalizationBtns = this.querySelectorAll('.group-personalization-button, .bulk-personalization-button, .personalization-buttons button:last-child');

        this.toggleModal = this.toggleModal.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
        this.showSwitchConfirmation = this.showSwitchConfirmation.bind(this);
        this.confirmSwitch = this.confirmSwitch.bind(this);
        this.cancelSwitch = this.cancelSwitch.bind(this);
        this.hideConfirmationPopup = this.hideConfirmationPopup.bind(this);

        this.addModalOpenClasses = this.addModalOpenClasses.bind(this);
        this.removeModalOpenClasses = this.removeModalOpenClasses.bind(this);

        this.init();
    }

    init() {
        this.modalButton?.addEventListener('click', () => this.toggleModal(true));        
        this.allModalClose.forEach(closeBtn => closeBtn?.addEventListener('click', () => this.toggleModal(false)));
        this.modalOverlay?.addEventListener('click', () => this.toggleModal(false));
        
        this.singlePersonalizationBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.showSwitchConfirmation('single');
            });
        });
        
        this.bulkPersonalizationBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.showSwitchConfirmation('bulk');
            });
        });

        this.confirmSwitchBtn?.addEventListener('click', () => this.confirmSwitch());
        this.cancelSwitchBtn?.addEventListener('click', () => this.cancelSwitch());
        this.popupCloseBtn?.addEventListener('click', () => this.hideConfirmationPopup());
        
        if (this.confirmationPopup) {
            const popupOverlay = this.confirmationPopup.querySelector('.popup-overlay');
            if (popupOverlay) {
                popupOverlay.addEventListener('click', () => this.hideConfirmationPopup());
            }
        }

        window.addEventListener("popstate", this.handleBackButton);
    }

    addModalOpenClasses() {
        const announcementBar = document.querySelector('.announcement-bar-section');
        const headerSticky = document.querySelector('.header-sticky');
        
        if (announcementBar) {
            announcementBar.classList.add('modal-open-active');
        }
        
        if (headerSticky) {
            headerSticky.classList.add('modal-open-active');
        }
        
    }

    removeModalOpenClasses() {
        const announcementBar = document.querySelector('.announcement-bar-section');
        const headerSticky = document.querySelector('.header-sticky');
        
        if (announcementBar) {
            announcementBar.classList.remove('modal-open-active');
        }
        
        if (headerSticky) {
            headerSticky.classList.remove('modal-open-active');
        }
    }
    resetProductCustomizer() {        
        setTimeout(() => {
            const productCustomizer = this.querySelector('product-customizer');
            if (productCustomizer) {                
                if (productCustomizer.resetAllSelections) {
                    productCustomizer.resetAllSelections();
                } else if (productCustomizer.reset) {
                    productCustomizer.reset();
                } else {
                    this.manualResetFallback();
                }
            } else {
                console.log('ℹ️ No product-customizer found in this modal');
            }
        }, 200);
    }

    manualResetFallback() {      
        const textInput = this.querySelector('#personalizedText');
        if (textInput) {
            textInput.value = '';
            textInput.classList.remove("red-outline");
        }
        
        const radioInputs = this.querySelectorAll('input[type="radio"]');
        radioInputs.forEach(input => {
            input.checked = false;
        });
        
        const firstFontStyle = this.querySelector('input[name="font-style"]');
        if (firstFontStyle) {
            firstFontStyle.checked = true;
        }
        const orientationButtons = this.querySelectorAll('.text-orientation__option');
        if (orientationButtons.length > 0) {
            orientationButtons.forEach(btn => btn.classList.remove("active"));
            orientationButtons[0].classList.add("active");
        }
        
        const textStep = this.querySelector('[data-step="text"]');
        const previewContainer = this.querySelector('.preview-step-container');
        const customizationContainer = this.querySelector('.customization-steps-container');
        
        if (previewContainer) previewContainer.classList.add('hidden-block');
        if (customizationContainer) customizationContainer.classList.remove('hidden-block');
        if (textStep) textStep.classList.add('active');
    }
    showSwitchConfirmation(targetModal) {                
        const isInSingleModal = this.modal.classList.contains('single-personalization-modal');
        const isInBulkModal = this.modal.classList.contains('bulk-personalization-modal');
        
        if ((isInSingleModal && targetModal === 'single') || (isInBulkModal && targetModal === 'bulk')) {
            return; 
        }        
        this.switchTo = targetModal;
        this.showConfirmationPopup();
    }

    showConfirmationPopup() {
        if (this.confirmationPopup) {
            this.confirmationPopup.classList.remove('hidden', 'hidden-block');
            this.confirmationPopup.classList.add('active');
            document.body.classList.add('overflow-hidden');
        } else {
            console.error('Confirmation popup element not found');
        }
    }

    confirmSwitch() {
        this.hideConfirmationPopup();
        
        if (this.switchTo === 'bulk') {
            const bulkPersonalizeElement = document.querySelector('.bulk-personalize');
            if (bulkPersonalizeElement) {
                bulkPersonalizeElement.classList.remove('bs-invisible');
            }
            this.switchToBulkModal();
        } else {
            const bulkPersonalizeElement = document.querySelector('.bulk-personalize');
            if (bulkPersonalizeElement) {
                bulkPersonalizeElement.classList.add('bs-invisible');
            }
            this.switchToSingleModal();
        }
        
        this.switchTo = null;
    }

    cancelSwitch() {
        this.hideConfirmationPopup();
        this.switchTo = null;
    }

    hideConfirmationPopup() {
        if (this.confirmationPopup) {                      
            this.confirmationPopup.classList.add('hidden', 'hidden-block');
            this.confirmationPopup.classList.remove('active');
            document.body.classList.remove('overflow-hidden');            
        }
    }

    // Add this to switchToBulkModal in PersonalizeModalContainer
    switchToBulkModal() {      
        this.toggleModal(false);  
        
        const bulkPersonalizeElement = document.querySelector('.bulk-personalize');
        if (bulkPersonalizeElement) {
            bulkPersonalizeElement.classList.remove('bs-invisible');
        }      
        
        setTimeout(() => {
            const bulkModalContainer = document.querySelector('.bulk-personalization-modal')?.closest('personalize-modal-container');
            
            if (bulkModalContainer) {                
                const bulkPersonalization = bulkModalContainer.querySelector('bulk-personalization');
                if (bulkPersonalization) {
                    // Sync variant from single personalization
                    if (bulkPersonalization.syncFromSinglePersonalization) {
                        bulkPersonalization.syncFromSinglePersonalization();
                    }
                    
                    // Reset bulk personalization
                    setTimeout(() => {
                        if (bulkPersonalization.resetBulkPersonalization) {
                            bulkPersonalization.resetBulkPersonalization();
                        }
                    }, 300);
                }
                
                bulkModalContainer.toggleModal(true);
            } else {
                console.error('Bulk modal container not found');
            }
        }, 300);
    }

    switchToSingleModal() {
        this.toggleModal(false);
        const bulkPersonalizeElement = document.querySelector('.bulk-personalize');
        if (bulkPersonalizeElement) {
            bulkPersonalizeElement.classList.add('bs-invisible');
        }
        setTimeout(() => {
            const singleModalContainer = document.querySelector('.single-personalization-modal')?.closest('personalize-modal-container');
                      
            if (singleModalContainer) {
                setTimeout(() => {
                    singleModalContainer.resetProductCustomizer();
                }, 300);
                singleModalContainer.toggleModal(true);

                
            } else {
                console.error('Single modal container not found');
                const singleButton = document.querySelector('.products-personalization-button.single-product');
                if (singleButton) {
                    const fallbackContainer = singleButton.closest('personalize-modal-container');
                    if (fallbackContainer) {
                        fallbackContainer.toggleModal(true);
                    }
                }
            }
        }, 300);
    }

    toggleModal(isOpening = null) {        
        const isOpen = this.modal.classList.contains('active');
        const shouldOpen = isOpening ?? !isOpen;
        
        if (shouldOpen) {
            document.body.classList.add('overflow-hidden');            
            this.modal.classList.add('active');
            history.pushState({ modalOpen: true }, "", location.href); 
            
            this.addModalOpenClasses();
            
            this.resetProductCustomizer();
            
        } else {                             
            
            document.body.classList.remove('overflow-hidden');
            this.modal.classList.remove('active');
            
            this.hideConfirmationPopup();
            const bulkPersonalizeElement = document.querySelector('.bulk-personalize');
            if (bulkPersonalizeElement) {
                bulkPersonalizeElement.classList.add('bs-invisible');
            }   

            this.removeModalOpenClasses();
            
            if (this.modal.classList.contains('single-personalization-modal')) {
                this.resetSinglePersonalization();
            } else if (this.modal.classList.contains('bulk-personalization-modal')) {
                this.resetBulkPersonalization();
            }
            if (history.state?.modalOpen) {
                history.replaceState(null, "", location.href);
            }
        }
    }
    
    resetSinglePersonalization() {
        const productCustomizer = this.querySelector('product-customizer');
        if (productCustomizer) {
            if (productCustomizer.resetAllSelections) {
                productCustomizer.resetAllSelections();
            } else if (productCustomizer.reset) {
                productCustomizer.reset();
            }
        }
    }
    
    resetBulkPersonalization() {
        const bulkPersonalization = this.querySelector('bulk-personalization');
        if (bulkPersonalization && bulkPersonalization.resetBulkPersonalization) {
            bulkPersonalization.resetBulkPersonalization();
        }
    }
    
    resetProductCustomizer() {
        const productCustomizer = this.querySelector('product-customizer');
        if (productCustomizer) {
            setTimeout(() => {
                if (productCustomizer.resetAllSelections) {
                    productCustomizer.resetAllSelections();
                } else if (productCustomizer.reset) {
                    productCustomizer.reset();
                }
            }, 100);
        }
    }

    handleBackButton(event) {
        if (this.modal.classList.contains('active') || 
            (this.confirmationPopup && !this.confirmationPopup.classList.contains('hidden'))) {
            this.toggleModal(false);
            event.preventDefault();
        }
    }
}
customElements.define('personalize-modal-container', PersonalizeModalContainer);

document.addEventListener("DOMContentLoaded", function () {
    const productAnchors = document.querySelectorAll(".personalized-products-options__container .product--anchor");
  
    productAnchors.forEach(anchor => {
      anchor.addEventListener("click", function (event) {
        // Prevent immediate navigation
        event.preventDefault();
  
        const rightClickIcon = anchor.querySelector(".right-click-icon");
        if (rightClickIcon) {
          // Show the icon
          rightClickIcon.style.display = "block";
  
          // Optionally add a quick animation effect (fade-in)
          rightClickIcon.style.opacity = 0;
          rightClickIcon.style.transition = "opacity 0.3s ease-in";
          requestAnimationFrame(() => rightClickIcon.style.opacity = 1);
        }
  
        // Wait 2.5 seconds, then redirect
        setTimeout(() => {
          window.location.href = anchor.href;
        }, 1000);
      });
    });
  });
  
class ConfirmDialog extends ModalContainer {
    constructor() {
        super();
        this.modalOverlay.replaceWith(this.modalOverlay.cloneNode(true));
        this.confirmButton = this.querySelector('modal-confirm');
        this.cancelButton = this.querySelector('modal-cancel');
        this.confirmButton?.addEventListener('click', () => this.confirmAction());
        this.cancelButton?.addEventListener('click', () => this.cancelAction());
    }

    confirmAction() {
        this.dispatchEvent(new CustomEvent('actionConfirmed'));
        this.toggleModal();
    }

    cancelAction() {
        this.dispatchEvent(new CustomEvent('actionAborted'));
        this.toggleModal();
    }
}

customElements.define('confirm-dialog', ConfirmDialog);


class CopyText extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.notCopiedIcon = this.querySelector("#not-copied");
        this.doneCopiedIcon = this.querySelector("#done-copied");
        this.copyValue = this.dataset.copyValue;
        this.addEventListener("click", (e) => this.copyToClipboard());
    }

    copyToClipboard() {
        navigator.clipboard.writeText(this.copyValue).then(() => this.updateUI());
    }

    updateUI() {
        this.toggleIcon("copied");
        document.body.querySelector('milton-toast')?.showSuccessToast(`Discount code copied: ${this.copyValue}`);
    }

    toggleIcon(state) {
        const isCopied = state === "copied";
        this.notCopiedIcon.dataset.active = isCopied ? "false" : "true";
        this.doneCopiedIcon.dataset.active = isCopied ? "true" : "false";

        if (isCopied) {
            setTimeout(() => this.toggleIcon("readyToCopy"), 3000);
        }
    }

}
customElements.define('copy-text', CopyText);

const copyTextElements = document.querySelectorAll('.copy-text-value');
const copyMessage = document.getElementById('copyMessages');

copyTextElements.forEach(element => {
    element.addEventListener('click', () => {
        const copiedText = element.getAttribute('data-copied-value');

        // Create a temporary textarea to copy the text
        const textarea = document.createElement('textarea');
        textarea.value = copiedText;
        document.body.appendChild(textarea);

        // Copy the text from textarea
        textarea.select();
        document.execCommand('copy');

        document.body.removeChild(textarea);
        copyMessage.style.display = 'block';

        setTimeout(() => {
            copyMessage.style.display = 'none';
        }, 1000);
    });
});

document.addEventListener("click", (e) => {
  const wrapper = e.target.closest(".copy-coupon-clipboard-wrapper");
  if (!wrapper) return;

  const couponCode = wrapper.querySelector("b")?.textContent.trim();
  if (!couponCode) return;

  const detailsSection = wrapper.closest("details.product-offers-wrapper");
  
  const messageContainer = detailsSection?.nextElementSibling?.classList.contains("copy-message-container") 
    ? detailsSection.nextElementSibling 
    : null;

  if (!messageContainer) {
    console.warn("Message container not found");
    return;
  }

  navigator.clipboard.writeText(couponCode).then(() => {
    messageContainer.innerHTML = '';
    messageContainer.innerHTML = `
      <div class="copy-success-message">
        ✅ Discount code copied: ${couponCode}
      </div>
    `;

    setTimeout(() => {
      messageContainer.innerHTML = '';
    }, 3000);
  }).catch((err) => {
    console.error("Failed to copy:", err);
    messageContainer.innerHTML = `
      <div class="copy-error-message">
        ❌ Failed to copy. Please try again.
      </div>
    `;
    setTimeout(() => {
      messageContainer.innerHTML = '';
    }, 3000);
  });
});